import { render, staticRenderFns } from "./CreateFontsForm.vue?vue&type=template&id=6369ba18&"
import script from "./CreateFontsForm.vue?vue&type=script&lang=js&"
export * from "./CreateFontsForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports